import { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Transition } from 'react-transition-group'

import Button from '@/components/Button/Button'
import IconButton from '@/components/Button/IconButton'
import { useRunnerState } from '@/composables/useRunnerState'
import { useRunnerUITransition } from '@/composables/useRunnerUITransition'

export type RunnerUIMobileProps = {
  isVisible: boolean
}

export default function RunnerUIMobile({ isVisible }: RunnerUIMobileProps) {
  const { t } = useTranslation()

  const { actor } = useRunnerState()

  const onPauseClick = useCallback(() => {
    actor.send({ type: 'PAUSE' })
  }, [actor])

  const onLeftClick = useCallback(() => {
    actor.send({ type: 'PLAYER_MOVE', direction: -1 })
  }, [actor])

  const onRightClick = useCallback(() => {
    actor.send({ type: 'PLAYER_MOVE', direction: 1 })
  }, [actor])

  const element = useRef<HTMLDivElement>(null)
  const { onEnter, onExit, timeout } = useRunnerUITransition(element, { from: 'bottom' })

  const isTouch = 'ontouchstart' in window
  const controlButtonsClass =
    'pointer-events-auto border-1 border-cream rounded-12 overflow-hidden bg-mid-blue text-white hover:outline-2 active:outline-2 outline-cream'

  return (
    <Transition
      in={isVisible}
      onEnter={onEnter}
      onExit={onExit}
      unmountOnExit
      mountOnEnter
      timeout={timeout}
      nodeRef={element}
    >
      <div
        ref={element}
        className={`RunnerUIMobile fixed z-80 left-0 w-full bottom-0 p-20 flex gap-16 justify-between items-center ${isTouch ? '' : 'hidden'}`}
      >
        <IconButton icon='triangle' style='squaredark' onClick={onLeftClick} className={controlButtonsClass} />
        <Button onClick={onPauseClick} className='pointer-events-auto'>
          {t('runner.pause')}
        </Button>
        <IconButton
          icon='triangle'
          style='squaredark'
          onClick={onRightClick}
          className={`${controlButtonsClass} rotate-180`}
        />
      </div>
    </Transition>
  )
}
